
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useStudentDetails = (studentId: string | null) => {
  return useQuery({
    queryKey: ['student-details', studentId],
    queryFn: async () => {
      if (!studentId) return null;
      
      
      
      try {
        const { data, error } = await supabase
          .from('students')
          .select(`
            *,
            student_activities(
              activity_id,
              status,
              activities(id, name, start_time, end_time, days_of_week)
            ),
            attendances(
              id,
              activity_id,
              date,
              status,
              time
            )
          `)
          .eq('id', studentId)
          .maybeSingle(); // Using maybeSingle instead of single to prevent errors if no data is found
        
        if (error) {
          throw error;
        }
        
        return data;
      } catch (error) {
        throw error;
      }
    },
    enabled: !!studentId,
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
};
